import { ImageCarousel, carousel } from "./carousel";
import { configureSearch } from "./search";
import { accordion } from "./accordion";
import { safeLog } from "./sanitize";

const onReady = () => {
  const carouselElem = document.getElementById("upcoming-events");
  if (carouselElem) carousel(carouselElem);

  var imageCarousels = document.querySelectorAll(".image-carousel-layout");
  imageCarousels.forEach(ImageCarousel);

  configureSearch();
  accordion();
  const burgerMenu = document.getElementById("burger-menu");
  const burgerMenuContent = document.getElementById("burger-menu-content");
  burgerMenu.addEventListener("click", e => {
    safeLog.debug("Burger menu clicked");
    e.preventDefault();
    burgerMenu.classList.toggle("active");
    burgerMenuContent.classList.toggle("active");
    return false;
  });


  let urlFilterList = [
    /^\/ask-trinny(\/|$)/i, // "/ask-trinny" or "/ask-trinny/..."
  ];

  const TrackPageViewFlag = !urlFilterList.some((regex) =>
    regex.test(document.location.pathname)
  );

  console.log("TrackPageViewFlag", TrackPageViewFlag, document.location.pathname);


  if (TrackPageViewFlag) {

    fetch("/api/analytics/pageview", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        url: document.location.href,
        userAgent: navigator.userAgent
      })
    });
  };
};

if (document.readyState !== "loading") onReady();
else document.addEventListener("DOMContentLoaded", onReady);

if ("serviceWorker" in navigator) {
  // Use the window load event to keep the page load performant
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/serviceworker.js", {
      updateViaCache: 'none'
    }).then(
      function () {
        safeLog.log("service worker", "service worker installed");
      },
      function () {
        safeLog.error("service worker", "error installing service worker");
      }
    );
  });
}
